const FT_TO_CM = 30.48;
const BACK_RATE_PER_M2 = 15; // back panel, $/m2
const MID_RATE_PER_M2 = 60; // inset front panel, $/m2
const MID_INSET_CM_PER_EDGE = 15; // front panel is inset 15cm from each edge
const LABOR = 20;
const FIXED_COST = 10;
const SHIPPING_SMALL = 30;
const SHIPPING_LARGE = 40;
const SHIPPING_THRESHOLD_M2 = 1.7; // back panel area cutoff between small/large shipping
const PAYMENT_FEE_RATE = 0.03;
const PROFIT_MIN = 50;
const PROFIT_MAX = 70;
const PROFIT_AREA_MIN_M2 = 1.08; // back panel area at 90x120cm reference size
const PROFIT_AREA_MAX_M2 = 2.43; // back panel area at 135x180cm reference size
const MIN_FT = 1;
const MAX_FT = 12;
const CALCULATED_VARIANT_TITLE = 'Custom (calculated)';

function computePrice(widthFt, heightFt) {
  const widthCm = widthFt * FT_TO_CM;
  const heightCm = heightFt * FT_TO_CM;

  const backAreaM2 = (widthCm / 100) * (heightCm / 100);
  const midWidthCm = Math.max(0, widthCm - MID_INSET_CM_PER_EDGE * 2);
  const midHeightCm = Math.max(0, heightCm - MID_INSET_CM_PER_EDGE * 2);
  const midAreaM2 = (midWidthCm / 100) * (midHeightCm / 100);

  const shipping = backAreaM2 > SHIPPING_THRESHOLD_M2 ? SHIPPING_LARGE : SHIPPING_SMALL;
  const cost = BACK_RATE_PER_M2 * backAreaM2 + MID_RATE_PER_M2 * midAreaM2 + LABOR + FIXED_COST + shipping;

  const areaRatio = Math.min(
    1,
    Math.max(0, (backAreaM2 - PROFIT_AREA_MIN_M2) / (PROFIT_AREA_MAX_M2 - PROFIT_AREA_MIN_M2))
  );
  const targetProfit = PROFIT_MIN + (PROFIT_MAX - PROFIT_MIN) * areaRatio;

  return Math.round((cost + targetProfit) / (1 - PAYMENT_FEE_RATE));
}

document.querySelectorAll('[data-custom-size-block]').forEach((block) => {
  const widthInput = block.querySelector('[data-custom-size-width]');
  const heightInput = block.querySelector('[data-custom-size-height]');
  const propertyInput = block.querySelector('[data-custom-size-property]');
  const note = block.querySelector('[data-custom-size-note]');
  const variantSelects = block.closest('product-info')?.querySelector('variant-selects');

  if (!widthInput || !heightInput || !propertyInput || !note) return;

  const formId = propertyInput.getAttribute('form');
  const sectionId = formId ? formId.replace('product-form-', '') : null;
  const realQuantityInput = sectionId ? document.getElementById(`Quantity-${sectionId}`) : null;
  const quantityInput = realQuantityInput || block.querySelector('[data-custom-size-fallback-quantity]');
  const quantityWrapper = realQuantityInput ? realQuantityInput.closest('.price-per-item__container') : null;
  const quantityLabel = realQuantityInput
    ? document.querySelector(`label.quantity__label[for="Quantity-${sectionId}"]`)
    : null;

  function setQuantityUIHidden(hidden) {
    if (quantityWrapper) quantityWrapper.hidden = hidden;
    if (quantityLabel) quantityLabel.hidden = hidden;
  }

  function setQuantity(value) {
    if (!quantityInput) return;
    quantityInput.value = value;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectCalculatedVariant() {
    if (!variantSelects) return false;
    const radio = variantSelects.querySelector(`input[type="radio"][value="${CSS.escape(CALCULATED_VARIANT_TITLE)}"]`);
    if (!radio) return false;
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function clearCustomSize() {
    widthInput.value = '';
    heightInput.value = '';
    propertyInput.value = '';
    note.hidden = true;
    widthInput.setCustomValidity('');
    heightInput.setCustomValidity('');
    setQuantityUIHidden(false);
    setQuantity(1);
  }

  function update() {
    const widthFt = parseFloat(widthInput.value);
    const heightFt = parseFloat(heightInput.value);

    widthInput.setCustomValidity('');
    heightInput.setCustomValidity('');

    if (!widthFt || !heightFt) {
      note.hidden = true;
      propertyInput.value = '';
      setQuantityUIHidden(false);
      return;
    }

    if (widthFt < MIN_FT || widthFt > MAX_FT || heightFt < MIN_FT || heightFt > MAX_FT) {
      const message = `Please enter a size between ${MIN_FT} and ${MAX_FT} ft per side, or contact us for larger orders.`;
      widthInput.setCustomValidity(message);
      heightInput.setCustomValidity(message);
      note.hidden = false;
      note.textContent = message;
      propertyInput.value = '';
      return;
    }

    if (!selectCalculatedVariant()) {
      const message = 'Custom pricing is not set up for this product yet - please contact us before ordering.';
      widthInput.setCustomValidity(message);
      heightInput.setCustomValidity(message);
      note.hidden = false;
      note.textContent = message;
      propertyInput.value = '';
      return;
    }

    const price = computePrice(widthFt, heightFt);

    propertyInput.value = `${widthFt} x ${heightFt} ft`;
    note.hidden = false;
    note.textContent = `Estimated price: $${price}`;
    setQuantityUIHidden(true);
    setQuantity(price);
  }

  widthInput.addEventListener('input', update);
  heightInput.addEventListener('input', update);

  if (variantSelects) {
    variantSelects.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('click', () => {
        if (widthInput.value === '' && heightInput.value === '') return;
        clearCustomSize();
      });
    });
  }
});
